import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';
const apiDomain = domain.API_BASE_URL;

export const fetchCities = createAsyncThunk(
    'cityList/fetchCities',
    async (planId) => {
      try {
        const apiUrl = `${apiDomain}v1/city-list`;
        const response = await api.get(apiUrl);
        // console.log("API Response fetchCities:", response.data);
        return response.data;
      } catch (error) {
        console.error("API Error in fetchCities:", error);
        throw error;
      }
    }
  );

  export const fetchStates = createAsyncThunk(
    'stateList/fetchStates',
    async (stateId) => {
      try {
        let apiUrl;
        if(stateId){
          apiUrl = `${apiDomain}v1/state-list?state_id=${stateId}`;
        }else{
          apiUrl = `${apiDomain}v1/state-list`;
        }
        const response = await api.get(apiUrl);
        console.log("API Response fetchStates:", response.data);
        return response.data;
      } catch (error) {
        console.error("API Error in fetchStates:", error);
        throw error;
      }
    }
  );

  const normalizeToArray = (data) => {
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') return [data];
    return [];
  };

const cityStateSlice = createSlice({
  name: 'cityStateList',
  initialState: {
    states: [],
    cities: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = normalizeToArray(action.payload);
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.cities = normalizeToArray(action.payload);
      });
  },
});

export default cityStateSlice.reducer;
